import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import titleize from 'titleize'
import { get } from 'lodash'
import humanizeString from 'humanize-string'

import { makeLink } from '../../../../common/utils/urlHelper'
import filterParamsConfig from '../../../../common/constants/filterParamsConfig'
import ArrowFillRightIcon from '../../icons/arrowFillRight'

const PanelHeader = props => {
  const {
    togglePanel,
    parsedLocation,
    rootCount,
    type,
    breadcrumbsLabel
  } = props

  const chosenOption = parsedLocation[type] || ''
  const delimiter = get(filterParamsConfig, `${type}.delimiter`)
  const chosenOptionArray = chosenOption.split(delimiter)
  const chosenOptionLength = chosenOptionArray.length
  const chosenOptionDisplayName = titleize(
    humanizeString(chosenOptionArray[chosenOptionLength - 1])
  )

  let BreadLinks = []
  for (let i = 0; i < chosenOptionLength; i++) {
    // return empty link for last item
    if (i === chosenOptionLength - 1) {
      BreadLinks.push(
        <a href="" key={i} className="is-last">
          <ArrowFillRightIcon
            width="9"
            height="13"
            className="breadcrumbs__icon"
          />
          {chosenOptionDisplayName}
        </a>
      )
    } else {
      let newQuery = Object.assign({}, parsedLocation)
      newQuery[type] = chosenOption.substring(
        0,
        chosenOption.indexOf(chosenOptionArray[i]) + chosenOptionArray[i].length
      )
      delete newQuery.page
      const link = makeLink(newQuery)
      BreadLinks.push(
        <Link onClick={togglePanel} key={i} rel="nofollow" to={link}>
          <ArrowFillRightIcon
            width="9"
            height="13"
            className="breadcrumbs__icon"
          />
          {titleize(humanizeString(chosenOptionArray[i]))}
        </Link>
      )
    }
  }

  // top level option link
  let rootQuery = Object.assign({}, parsedLocation)
  delete rootQuery[type]
  const rootLink = makeLink(rootQuery)

  return (
    <div className="search-facet-panel__breadcrumbs-wrapper">
      <div className="search-facet-panel__breadcrumbs-intro">
        <span className="fds-c-text-body -size-s">Show:</span>
      </div>
      <div className="search-facet-panel__breadcrumbs">
        <nav className="breadcrumbs -line-wrap -color-grey -icon-fill fds-u-text-truncate">
          <Link onClick={togglePanel} rel="nofollow" to={rootLink}>
            All {breadcrumbsLabel}
            <span className="breadcrumbs__count">{rootCount}</span>
          </Link>
          {BreadLinks}
        </nav>
      </div>
    </div>
  )
}

PanelHeader.propTypes = {
  togglePanel: PropTypes.func.isRequired,
  parsedLocation: PropTypes.object.isRequired,
  rootCount: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  breadcrumbsLabel: PropTypes.string.isRequired
}

export default PanelHeader



// WEBPACK FOOTER //
// ./client/components/filters/filtersPanel/panelHeader.js